<div class="row billet-position">
  <div class="col-3 p-0">
    <div class="title">{{ dense ? 'Pos. do dia' : 'Posição do dia' }}</div>
    <div class="value" [ngClass]="positionNetDayClass">{{ listPosition?.netDay ? listPosition?.netDay : '-' }}</div>
  </div>
  <div class="col-3 p-0">
    <div class="title">P. Médio</div>
    <div class="value">{{ listPosition?.averagePricePos ? listPosition.averagePricePos : '-' }}</div>
  </div>
  <div class="col-3 p-0">
    <div class="title">L/P Aberto</div>
    <div class="value"
      [ngClass]="{'high': listPosition?.openProfitLossColor > 0, 'low': listPosition?.openProfitLossColor < 0}">
      {{ listPosition?.openProfitLoss ? listPosition.openProfitLoss : '-' }}</div>
  </div>
  <div class="col-3 p-0">
    <div class="title">L/P Fechado</div>
    <div class="value"
      [ngClass]="{'high': listPosition?.closedProfitLossColor > 0, 'low': listPosition?.closedProfitLossColor < 0}">
      {{ listPosition?.closedProfitLoss ? listPosition.closedProfitLoss : '-' }}</div>
  </div>
</div>
